const topicDropdownData = "contact_form.topic_dropdown_data";

export enum ContactFormSubjectEnum {
  EASY_FUEL = `${topicDropdownData}.easyfuel`,
  PRICES = `${topicDropdownData}.prices`,
  PAYMENT = `${topicDropdownData}.payment`,
  INVOICES = `${topicDropdownData}.invoices`,
  CLOSE_LOCATION = `${topicDropdownData}.close_location`,
  LOCATIONS = `${topicDropdownData}.locations`,
  TRANSACTIONS = `${topicDropdownData}.transactions`,
  MARKETING = `${topicDropdownData}.marketing`,
  OTHER = `${topicDropdownData}.other`,
}
